// Table of contents:
// 1 deliveryForecasts
// 2 deliveryForecastsDespatchAdvices
import { DeliveryForecasts } from '../../../data'
import { getTranslationsForConfig } from '../getTranslationsForConfig'

export const createDeliveryForecasts = (): DeliveryForecasts => {
  return {
    // 1 deliveryForecasts
    deliveryForecast: {
      enabled: true,
      table: {
        enabled: true,
        columns: [
          {
            // Lieferplannummer
            dataType: 'string',
            field: 'Payload.ScheduleAgreementNumber',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.scheduleAgreementNumber.filterPlaceholder',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.scheduleAgreementNumber.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.scheduleAgreementNumber.header',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.scheduleAgreementNumber.header')
            sortable: true,
          },
          {
            // Position
            dataType: 'string',
            field: 'Payload.Item.Position',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.position.filterPlaceholder',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.position.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.position.header',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.position.header')
            sortable: true,
          },
          {
            // Werk
            dataType: 'string',
            field: 'Payload.Item.Plant',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.plant.filterPlaceholder',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.plant.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.plant.header',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.plant.header')
            sortable: true,
          },
          {
            // Abladestelle
            dataType: 'string',
            field: 'Payload.Item.UnloadingPoint',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.unloadingPoint.filterPlaceholder',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.unloadingPoint.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.unloadingPoint.header',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.unloadingPoint.header')
            sortable: true,
          },
          {
            // Artikelnummer
            dataType: 'string',
            field: 'Payload.Item.BuyerProductId',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.buyerProductId.filterPlaceholder',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.buyerProductId.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.buyerProductId.header',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.buyerProductId.header')
            sortable: true,
          },
          {
            // Artikelbezeichnung
            dataType: 'string',
            field: 'Payload.Item.BuyerProductDescription',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.buyerProductDescription.filterPlaceholder',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.buyerProductDescription.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.buyerProductDescription.header',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.buyerProductDescription.header')
            sortable: true,
          },
          {
            // Abrufnummer
            dataType: 'string',
            field: 'Payload.CurrentReleaseNumber',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.currentReleaseNumber.filterPlaceholder',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.currentReleaseNumber.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.currentReleaseNumber.header',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.currentReleaseNumber.header')
            sortable: true,
          },
          {
            // Eingangsfortschrittszahl
            align: 'right',
            dataType: 'number',
            field: 'Payload.Item.CummulativeQuantityReceived',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.cummulativeQuantityReceived.filterPlaceholder',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.cummulativeQuantityReceived.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.cummulativeQuantityReceived.header',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.cummulativeQuantityReceived.header')
            sortable: true,
          },
          {
            // Letzter Wareneingang
            align: 'right',
            dataType: 'date',
            field: 'Payload.Item.LastReceiving.Date',
            filter: true,
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.modificationDate.header',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.modificationDate.header')
            sortable: true,
          },
          {
            // Status
            alignFrozen: 'right',
            dataType: 'status',
            field: 'Payload.ConfirmationCode',
            filter: true,
            frozen: true,
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecasts.table.columns.confirmationCode.header',
            ), // i18n.t('deliveryForecasts.deliveryForecasts.table.columns.confirmationCode.header')
            sortable: true,
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'deliveryForecasts.deliveryForecasts.table.emptyMessageDetails',
        ), // i18n.t('deliveryForecasts.deliveryForecasts.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'deliveryForecasts.deliveryForecasts.table.emptyMessageTitle',
        ), // i18n.t('deliveryForecasts.deliveryForecasts.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Payload.ScheduleAgreementNumber',
        sortOrder: 1,
      },
    },
    // 2 despatchAdvices
    despatchAdvice: {
      enabled: true,
      table: {
        enabled: true,
        columns: [
          {
            // Lieferplannummer
            dataType: 'string',
            field: 'Payload.OrderId',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.scheduleAgreementNumber.filterPlaceholder',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.scheduleAgreementNumber.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.scheduleAgreementNumber.header',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.scheduleAgreementNumber.header')
            sortable: true,
          },
          {
            // Position
            align: 'right',
            dataType: 'string',
            field: 'Payload.Item.DesAdvPosition',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.position.filterPlaceholder',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.position.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.position.header',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.position.header')
            sortable: true,
          },
          {
            // Werk
            align: 'right',
            dataType: 'string',
            field: 'Payload.Plant',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.plant.filterPlaceholder',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.plant.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.plant.header',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.plant.header')
            sortable: true,
          },
          {
            // Abladestelle
            align: 'right',
            dataType: 'string',
            field: 'Payload.UnloadingPoint',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.unloadingPoint.filterPlaceholder',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.unloadingPoint.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.unloadingPoint.header',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.unloadingPoint.header')
            sortable: true,
          },
          {
            // Artikelnummer
            align: 'right',
            dataType: 'string',
            field: 'Payload.Item.BuyerProductId',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.buyerProductId.filterPlaceholder',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.buyerProductId.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.buyerProductId.header',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.buyerProductId.header')
            sortable: true,
          },
          {
            // Artikelbezeichnung
            align: 'right',
            dataType: 'string',
            field: 'Payload.Item.BuyerProductDescription',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.buyerProductDescription.filterPlaceholder',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.buyerProductDescription.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.buyerProductDescription.header',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.buyerProductDescription.header')
            sortable: true,
          },
          {
            // Abrufnummer
            align: 'right',
            dataType: 'string',
            field: 'Payload.CurrentReleaseNumber',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.currentReleaseNumber.filterPlaceholder',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.currentReleaseNumber.filterPlaceholder')
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.currentReleaseNumber.header',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.currentReleaseNumber.header')
            sortable: true,
          },
          {
            // Bestätigtes Lieferdatum
            align: 'left',
            dataType: 'date',
            field: 'Payload.DeliveryDate',
            filter: true,
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.orderDeliveryDate.header',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.orderDeliveryDate.header')
            sortable: true,
          },
          {
            // Bestätigte Menge
            align: 'right',
            dataType: 'string', // number
            field: 'Payload.Item.ConfirmationQuantity',
            filter: true,
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.confirmationQuantity.header',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.confirmationQuantity.header')
            sortable: true,
          },
          {
            // Lieferart
            align: 'left',
            dataType: 'deliveryType',
            field: 'Payload.DeliveryType',
            filter: true,
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.deliveryType.header',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.deliveryType.header')
            sortable: true,
          },
          {
            // Status
            alignFrozen: 'right',
            dataType: 'status',
            field: 'Payload.ConfirmationCode',
            filter: true,
            frozen: true,
            header: getTranslationsForConfig(
              'deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.confirmationCode.header',
            ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.columns.confirmationCode.header')
            sortable: true,
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'deliveryForecasts.deliveryForecastsDespatchAdvices.table.emptyMessageDetails',
        ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'deliveryForecasts.deliveryForecastsDespatchAdvices.table.emptyMessageTitle',
        ), // i18n.t('deliveryForecasts.deliveryForecastsDespatchAdvices.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        multiSortMeta: [
          { field: 'Payload.OrderId', order: 1 },
          { field: 'Payload.OrderDeliveryDate', order: 1 },
        ],
      },
    },
  }
}
